import { render, staticRenderFns } from "./InputTextSecondary.vue?vue&type=template&id=1be35972&scoped=true"
import script from "./InputTextSecondary.vue?vue&type=script&lang=js"
export * from "./InputTextSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be35972",
  null
  
)

export default component.exports